module.exports = __webpack_public_path__ + "static/logo-footer-278e675be8fe613a3dd60180fbb7aac9.svg";